
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBlowerOffHorizontal as ObiBlowerOffHorizontalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-blower-off-horizontal.js';
 
 
 

 
 export const ObiBlowerOffHorizontal = createComponent({
   react: React,
   tagName: 'obi-blower-off-horizontal',
   elementClass: ObiBlowerOffHorizontalElement,
   events: {
     
   }
  });
 
 